module.exports = __webpack_public_path__ + "static/media/LogicLever6_1_row_2.14fa4e50.png";